export default __webpack_public_path__ + "static/media/password.16706ddf.ttf";